import {
    DELETE_SUBCATEGORY,
    DELETE_SUBCATEGORY_FAILURE,
    DELETE_SUBCATEGORY_SUCCESS,
} from 'store/actions/types';

export const deleteSubcategory = (payload) => {
    return {
        type: DELETE_SUBCATEGORY,
        payload: payload,
    };
};

export const deleteSubcategoryFailure = (error) => {
    return {
        type: DELETE_SUBCATEGORY_FAILURE,
        error: error,
    };
};

export const deleteSubcategorySuccess = (payload) => {
    return {
        type: DELETE_SUBCATEGORY_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/subcategories/deleteSubcategories.js